import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { ControlledRadioGroup } from '@act/storybook';
import { Control } from 'react-hook-form';
import type { SurveyFormData } from './types';

export interface RadioGroupInputProps {
  control: Control<SurveyFormData>;
  name: string;
  options: SurveyV2.OptionDto[];
  isRequired: boolean;
  togglePrompt: (prompt: SurveyV2.PromptDto) => void;
}

const RadioGroupInput = ({
  control,
  name,
  options,
  isRequired,
  togglePrompt,
}: RadioGroupInputProps) => {
  const formattedOptions = options.map(option => {
    return {
      label: option.text,
      value: `${option.id}`,
      callback: () => togglePrompt(option.prompt),
    };
  });

  return (
    <ControlledRadioGroup<SurveyFormData, typeof name>
      trackingName="survey-radio-group"
      control={control}
      name={name}
      options={formattedOptions}
      required={isRequired}
    />
  );
};

export default RadioGroupInput;
